const textNodeToLatexPrinter = (node) => {
  return sanitizeLatexText(node.value);
};
function sanitizeLatexText(text) {
  return text.replaceAll("\\(", "$").replaceAll("\\)", "$").replaceAll(/(`\{|\}|\[|\])/g, ($1) => `\\${$1}`);
}

export { sanitizeLatexText, textNodeToLatexPrinter };
//# sourceMappingURL=common.text.js.map
